export default __webpack_public_path__ + "static/media/years_in_business_unit.e4eff928.svg";